import * as React from "react";
import Particles from "react-tsparticles";

const ParticlesBackground1 = () =>{
  return (
    <div className="App">
      <Particles
        params={{
          background: {
            color: {
              value: "#0048D7"
            }
          },
          fpsLimit: 120,
          interactivity: {
            detectsOn: "canvas",
            events: {
              onClick: {
                enable: true,
                mode: "push"
              },
              onHover: {
                enable: true,
                mode: "repulse"
              },
              resize: true
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
                speed: 2
              },
              push: {
                quantity: 4
              },
              repulse: {
                distance: 200,
                duration: 1.0
              }
            }
          },
          particles: {
            color: {
              value: "#FFFFFF"
            },
            links: {
              color: "#FFFFFF",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1
            },
            collisions: {
              enable: true
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 3,
              straight: false
            },
            number: {
              density: {
                enable: true,
                value_area: 800
              },
              value: 20
            },
            opacity: {
              value: 0.5
            },
            shape: {
              type: "circle"
            },
            size: {
              random: true,
              value: 5
            }
          },
          detectRetina: true
        }}
      />
    </div>
  );
}
export default ParticlesBackground1